import { Injectable } from '@angular/core';
import { ApiProvider } from '../providers/api.provider';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelService {
  constructor(private apiProvider: ApiProvider) {}

  /**
   * Returns true if successful
   */
  public printLabels(shippingIds: number[]): Observable<any> {
    // return this.apiProvider.printLabels(shippingId);
      return this.apiProvider.printLabels(shippingIds);
  }
}
